export default { id: process.env.REACT_APP_GTM_ID };
